export function getErrorMessage(
  error: any,
  message: string = "Ocorreu um erro inesperado. "
) {
  if (error) {
    console.log('error:', error);
    if (error.error) {
      const throwError = error.error;
      if (typeof throwError === "string") {
        return throwError;
      }
      if (throwError.response) {
        if (typeof throwError.response.mensagem === "string") {
          return throwError.response.mensagem;
        }
      }
      if (throwError.Message) {
        if (typeof throwError.Message === "string") {
          return throwError.Message;
        }
      }
      if(throwError.Errors){
        if(throwError.Errors.length > 0){
          if(throwError.Errors[0]?.Message)
            return throwError.Errors[0]?.Message ?? message;
        }
      }
    }
  }
  return message;
}
